<template>
    <div>
        <div v-if="component.type === 'text' && component.options.hidden === false" class="columns m-h-auto is-vcentered">
            <div class="column is-4 printWidth">
                <p v-if="!component.options.hideLabel && component.display.label !== ''" class="is-size-6 th is-flex ai-center">{{component.display.label}}:
                <b-tooltip  v-if="component.options.toolTip !== ''" :label="component.options.toolTip" size="is-small" class="mg-l-5" type="is-dark">
                <b-icon pack="fas" size="is-small" icon="question-circle" class="has-text-grey-light"></b-icon>
                </b-tooltip>
                </p>
            </div>
            <div class="column is-8 printWidth th">
                <div v-if="typeof dataInputKpi[component.name] !== 'undefined' && typeof component.options !== 'undefined' && typeof component.options.repeat !== 'undefined' && component.options.repeat === true">
                    <p class="th" v-if="dataInputKpi[component.name].input !== ''"><span class="has-text-weight-normal">ข้อมูลล่าสุด: </span><span>{{dataInputKpi[component.name].input}}</span><span v-if="dataInputKpi[component.name].lastUpdate !== null"> เมื่อ {{dataInputKpi[component.name].lastUpdate  | dateFomatShortmonth}}</span></p>
                </div>
                <p v-if="input[component.name] !== null && input[component.name] !== ''">{{input[component.name]}}</p>
                <i  v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
            </div>
        </div>
        <div v-if="component.type === 'textarea'" class="columns m-h-auto is-vcentered  pd-y-5">
            <div class="column is-4 printWidth">
                <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}:</p>
            </div>
            
            <div class="column is-8 printWidth th">
                <p v-if="input[component.name] !== null && input[component.name] !== ''">{{input[component.name]}}</p>
                <i  v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
            </div>
        </div>
        <div v-if="component.type === 'select'" class="columns m-h-auto is-vcentered  pd-y-5">
            <div class="column is-4 printWidth">
                <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}:</p>
            </div>
            <div class="column is-8 printWidth th">
                <p v-if="input[component.name] !== null && input[component.name] !== '' && component.display.choice === 'phoneNumber'">{{input[component.name].formatInternational}}</p>
                <p v-else-if="input[component.name] !== null && input[component.name] !== ''">{{input[component.name].label}}</p>
                <i  v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
            </div>
        </div>
        <div v-if="component.type === 'file'" class="columns m-h-auto is-vcentered pd-y-5">
            
            <div class="column is-4 printWidth">
                <p v-if="!component.options.hideLabel && component.display.label !== ''" class="is-size-6 th is-flex ai-center">{{component.display.label}}:
                <b-tooltip  v-if="component.options.toolTip !== ''" :label="component.options.toolTip" size="is-small" class="mg-l-5" type="is-dark">
                <b-icon pack="fas" size="is-small" icon="question-circle" class="has-text-grey-light"></b-icon>
                </b-tooltip>
                </p>
            </div>
            <div class="column is-8 printWidth th">
                <div v-if="input[component.name] !== null && typeof input[component.name][0] === 'undefined'">
                    <a :href="urlFile+roleId+'/'+input[component.name].name" target="_blank">{{input[component.name].name}}</a>
                </div>
                <div v-else-if="input[component.name] !== null && input[component.name].length !== 0">
                    <div v-for="(item,index) in input[component.name]" :key="index">
                        <a :href="urlFile+roleId+'/'+item.name" target="_blank">{{item.name}}</a>
                    </div>
                </div>
                <i  v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
            </div>
        </div>
        <div v-if="component.type === 'date'" class="columns m-h-auto is-vcentered pd-y-5">
            <div class="column is-4 printWidth">
                <p v-if="component.display.label !== ''" class="is-size-6 th">{{component.display.label}}:</p>
            </div>
            <div class="column is-8 printWidth th" :class="{'is-6':component.options.type === 'date','is-4':component.options.type === 'datetime'}" v-if="component.options.type === 'date' || component.options.type === 'datetime' ">
                <p v-if="input[component.name] !== null && input[component.name] !== ''">{{input[component.name]  | dateFomatShortmonth}}</p>
                <i  v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
            </div>
        </div>
        <div v-if="component.type === 'radio'" class="columns m-h-auto  pd-y-5">
            <div class="column is-4 printWidth">
                <p  class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}:</p>
            </div>
            <div class="column is-8 printWidth th" >
                <p v-if="input[component.name] !== null && input[component.name] !== ''">
                    <span v-if="input[component.name].data !== null">
                        <span v-if="input[component.name].data.userValue === true">
                            {{ input[component.name].des }}
                        </span>
                        <span v-else>
                            {{ input[component.name].data.label }}
                        </span>
                    </span>
                </p>
                <i  v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
            </div>
        </div>
        <div v-if="component.type === 'checkbox'" class="columns m-h-auto pd-y-5">
            <div class="column is-4 printWidth">
                <p  class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}:</p>
            </div>
            <div class="column is-8 printWidth th">
                <div v-if="input[component.name] !== null && input[component.name].length !== 0">
                    <div v-for="(item,index) in input[component.name]" :key="index">
                        <p v-if="item.userValue === false">{{item.label}}</p>
                        <p v-else>{{item.des}}</p>
                    </div>
                </div>
                <i  v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['component','input','dataInputKpi'],
    computed: {
        roleId(){
            if (typeof this.$route.params.roleId !== 'undefined' && this.$route.params.roleId !== '') {
                return this.$route.params.roleId
            }else{
                return this.user._id
            }
        },
        user(){
            return this.$store.state.user
        }
    },
    data() {
        return {
            urlFile: process.env.VUE_APP_URL_DYNAMIC,
        }
    },
}
</script>

<style scoped>

</style>
